// @flow

import React, {useEffect, useContext} from 'react';
import {convertPxToRem} from '@pb/kit-util-convert-px-to-rem';

import {Headers} from './data-table-headers';
import {DataTableContext} from '../contexts/data-table-context';
import {useHeaders} from '../hooks/use-headers';

import type {ComponentType, Node} from 'react';
import type {HeadersProps} from './data-table-headers';
import type {DataTableContextType} from '../contexts/data-table-context';

export const MainHeader: ComponentType<HeadersProps> = (props: HeadersProps): Node => {
    const {
        children,
        className,
        disabledScroll,
        getHeaderTopOffset,
        hasPinnedRows = false,
        modal = false,
        stickyReferenceElement,
        ...restProps
    } = props;

    const {isSticky, headersContainer, headerRef, topPosition} = useHeaders({
        isMainHeaders: true,
        getHeaderTopOffset,
        stickyReferenceElement,
        hasPinnedRows,
    });

    const {mainHeaderHeightRef} = useContext<DataTableContextType>(DataTableContext);

    useEffect(() => {
        if (headerRef.current && mainHeaderHeightRef) {
            mainHeaderHeightRef.current = headerRef.current.offsetHeight;
        }
    }, []);

    const style = !modal ? {'--top-position': convertPxToRem(topPosition)} : {};

    return (
        <Headers
            {...restProps}
            className={className}
            disabledScroll={disabledScroll}
            isSticky={isSticky}
            headersContainer={headersContainer}
            headerRef={headerRef}
            style={style}>
            {children}
        </Headers>
    );
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../contexts/data-table-context");

require("./data-table-headers");
